import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isLoading: false,
    isLogged: false,
    id: null,
    user: null,
    level: null,
    isUserPurchaseAvailable: null,
    favourites: [],
    requests: [],
    token: null
}
const userSlice = createSlice({
    name: 'user',
    initialState: initialState,
    reducers: {
        getLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        getLogged: (state, action) => {
            state.isLogged = true;
            state.id = action.payload.id;
            state.user = action.payload.name;
            state.level = action.payload.level;
            state.isUserPurchaseAvailable = action.payload.isUserPurchaseAvailable;
            state.isUserShopOrderAvailable = action.payload.isUserShopOrderAvailable;
            state.favourites = action.payload.favourites;
            state.requests = action.payload.requests;
            state.token = action.payload.token;
            state.isLoading = false;
        },
        getUnlogged: () => initialState, //
        setFavourite: (state, action) => {
            const { activityId, isFavourite } = action.payload
            if (isFavourite) {
                if (!state.favourites.includes(activityId)) {
                    state.favourites.push(activityId)
                }
            } else {
                if (state.favourites.includes(activityId)) {
                    const newFavourites = state.favourites.filter(element => element !== activityId);
                    state.favourites = newFavourites;
                }
            }
        }
    }
})

export const { getLogged, getUnlogged, getLoading, setFavourite } = userSlice.actions;
export default userSlice.reducer;